export default __webpack_public_path__ + "static/media/preview-video-1.72cc0a74.jpg";